function t(t){return 0===t?"Off":t>=1e3?t/1e3+"k":t.toString()}export{t as formatInputSliderMark};
//# sourceMappingURL=formatInputSliderMark.js.map
